import React from "react";
import Carousel from "./carousel.js";
import ButtonOrang from "./ButtonOrang.js";

export default function BlogDetailContent({ blog }) {
  const apiUrl = "https://api.institucional.global.sidom.io";
  return (
    <section className="relative pt-40 md:pb-24 pb-16">
      <div className="container relative ">
        <div className="md:flex text-left ">
          <div className="lg:w-3/5 mb-[60px]">
            <h5 className=" text-4xl md:leading-normal leading-normal font-medium">
              {blog.titulo}
            </h5>
            <div className="flex mt-5">
              <span className="font-medium">
                <i className="mdi mdi-calendar-blank-outline me-2"></i>
                {blog.fecha_publicacion || "Sin fecha"}
              </span>
            </div>
          </div>
        </div>

        <div className="flex justify-start items-start text-left">
          <div className="lg:w-full ">
            <div className="relative  ">
              {blog.imagen && blog.imagen[0]?.url && (
                <img
                  src={`${apiUrl}${blog.imagen[0].url}`}
                  className="rounded-xl w-full shadow-md dark:shadow-gray-800"
                  alt={blog.titulo}
                />
              )}
            </div>
          </div>
        </div>

        <div className="flex justify-start mt-[30px]">
          <div className=" text-left text-lg">
            {Array.isArray(blog.contenido) &&
              blog.contenido.map((bloque, idx) => {
                if (
                  bloque.type === "paragraph" &&
                  Array.isArray(bloque.children)
                ) {
                  return (
                    <p
                      key={idx}
                      className="text-sidom-dark dark:text-sidom-light text-lg mt-4"
                    >
                      {bloque.children.map((child, i) => {
                        if (
                          child.type === "link" &&
                          child.url &&
                          Array.isArray(child.children)
                        ) {
                          return (
                            <a
                              key={i}
                              href={child.url}
                              className="text-sidom-orange underline hover:text-sidom-orange/70"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {child.children.map((subChild, j) => {
                                if (subChild.bold && subChild.italic) {
                                  return (
                                    <strong key={j}>
                                      <em>{subChild.text}</em>
                                    </strong>
                                  );
                                } else if (subChild.bold) {
                                  return (
                                    <strong key={j}>{subChild.text}</strong>
                                  );
                                } else if (subChild.italic) {
                                  return <em key={j}>{subChild.text}</em>;
                                } else {
                                  return <span key={j}>{subChild.text}</span>;
                                }
                              })}
                            </a>
                          );
                        }

                        if (child.bold && child.italic) {
                          return (
                            <strong key={i}>
                              <em>{child.text}</em>
                            </strong>
                          );
                        } else if (child.bold) {
                          return <strong key={i}>{child.text}</strong>;
                        } else if (child.italic) {
                          return <em key={i}>{child.text}</em>;
                        } else {
                          return <span key={i}>{child.text}</span>;
                        }
                      })}
                    </p>
                  );
                }
                return null;
              })}
          </div>
        </div>

        <div className="mt-[100px] mb-[100px]">
          {Array.isArray(blog.img) && blog.img.length > 0 && (
            <Carousel images={blog.img} />
          )}
        </div>

        <div className="flex justify-center items-center">
          <ButtonOrang text={"hola"} />
        </div>
      </div>
    </section>
  );
}
